import { projects } from '../../constants';
import ProjectCard from '../ProjectCard';

function RelatedProjects({ currentProjectId }) {
  // Filter out current project and get 3 other projects
  const relatedProjects = projects
    .filter(project => project.id !== currentProjectId)
    .slice(0, 3);

  if (relatedProjects.length === 0) return null;

  return (
    <section className="py-12 md:py-16 px-6 md:px-12 bg-[#F7F7F7]">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-playfair font-normal text-[#0D0D0D] mb-8 md:mb-12 text-center">
          More Projects
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-8">
          {relatedProjects.map((project, index) => (
            <ProjectCard key={project.id} {...project} delay={0} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default RelatedProjects;
